<template>
  <section>
    <div class="c-modal"  :style="{display: show ? 'block' : 'none', 'z-index': 302}">
      <div class="c-modal__dialog c-modal__dialog--center" :class="{setCover: set_cover}">
          <!-- Modal content -->
          <div class="c-modal__content">
            <div class="c-modal__title">
              ご確認ください
            </div>
            <div class="c-modal__body" v-html="nl2br(message)">
            </div>
            <div class="c-modal__buttons">
              <a href="javascript:void(0)" @click.prevent="closeModal" class="c-btn-close">
                <img src="/assets/images/icon/icon-close-black.svg" alt="" />閉じる
              </a>
            </div>
          </div>
      </div>
    </div>
    <div class="c-modal" :style="{display: confirm_show ? 'block' : 'none', 'z-index': 9999}">
      <div class="c-modal__dialog c-modal__dialog--center" :class="{setCover: set_cover}">
          <!-- Modal content -->
          <div class="c-modal__content">
            <div class="c-modal__title">
              {{confirm_title || 'ご確認ください'}}
            </div>
            <div class="c-modal__body" v-html="nl2br(confirm_message)" :style="{'text-align': confirm_centering ? 'center' : 'left'}">
            </div>
            <slot />
            <div class="c-modal__buttons" v-if="isShowButton != false">
              <a href="javascript:void(0)" @click.prevent="confirmed(false)" class="c-btn-close" v-if="!confirm_hide_cancel">
                {{label_cancel ? label_cancel : 'キャンセル'}}
              </a>
              <a href="javascript:void(0)" @click.prevent="confirmed(true)" class="c-btn-close c-btn--no-arrow c-btn__red">
                {{label_ok ? label_ok : 'OK'}}
              </a>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { eventBus, Common } from "../common/common";

export default Vue.extend({
  name: 'alert',
  props: ['isShowButton','message', 'show', 'closeModal', 'confirm_show', 'confirm_message', 'confirm_callback', 'confirm_hide_cancel', 'label_ok', 'label_cancel', 'confirm_title', 'confirm_centering','set_cover'],
  data() {
    return {
      in_call: true
    }
  },
  created(){
    eventBus.$on("answerCall", function(){
      this.in_call = true;
    });
    eventBus.$on("endCall", function(){
      this.in_call = false;
    })
  },
  components: {
  },
  methods: {
    confirmed(result){
      if (this.confirm_callback) {
        this.confirm_callback(result);
      }
      this.closeModal();
    },
    endCall(){
      Common.endCall();
    },
    nl2br(value) {
      return value?.replace(/\n/gi, "<br/>\n");
    }
  }
})
</script>
